import eventbus from '../../eventBus';
import { getDateMonthsBefore, getDateDayBefore } from "../../shared/utils";
import * as lang from "vuejs-datepicker/src/locale";
import moment from 'moment';
export default {
    inject: ['$validator'],
    data() {
      return {
        loading: false,        
        result: this.getEmptyResult(),      
        languages: lang,
        zeroAsString: (0).toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' }),
        currentPage: 1
      }
    },
    mounted() {
        const self = this;
        eventbus.$on(`transactions-filter:search`, function() {
            self.search();
        });
    },
    methods: {
        search() {
            this.fetchData(1);
        },
        getEmptyResult() {
            return {
                pageIndex: 1,
                pageSize: 0,
                rowCount: 0,
                data: []
            };
        },
        formatDateTime(value) {
            return value == null || value == '' ? '' : moment(value).format('DD/MM/YYYY - HH:mm:ss');
        },
        onPageIndexChanged(p) {
            this.fetchData(p);
        },
        showLoading() {
            this.loading = true;
            eventbus.$emit("ui-action:loading", true);
        },
        hideLoading() {
            this.loading = false;
            eventbus.$emit("ui-action:loading", false);
        },         
        formatDecimal(value) {
            return value == null || value == '' ? 'R$ 0,00' : value.toLocaleString('pt-BR', { style: 'currency', currency: 'BRL' });
        },
    }
}